import type { ChecklistItem as BoardChecklistItem } from '../../types/schema'

export type ChecklistSnapshotRow = {
  id: string
  data: Partial<BoardChecklistItem> & { sourceChecklistId?: string | null; text?: string }
}

export const checklistBoardSessionSnapshotCache = new Map<string, BoardChecklistItem[]>()

export const invalidateChecklistBoardSessionSnapshot = (workspaceId?: string) => {
  if (!workspaceId) {
    checklistBoardSessionSnapshotCache.clear()
    return
  }
  const prefix = `${workspaceId}::`
  for (const key of checklistBoardSessionSnapshotCache.keys()) {
    if (key.startsWith(prefix)) {
      checklistBoardSessionSnapshotCache.delete(key)
    }
  }
}

export const cloneBoardSnapshot = (
  snapshot: readonly BoardChecklistItem[],
): BoardChecklistItem[] => JSON.parse(JSON.stringify(snapshot)) as BoardChecklistItem[]

export const checklistBoardSessionKeyFor = (
  workspaceId: string,
  scopeId: string,
  mode?: 'DAILY' | 'WEEKLY',
  focusedKey?: string,
) => mode && focusedKey
  ? `${workspaceId}::${scopeId}::${mode}::${focusedKey}`
  : `${workspaceId}::${scopeId}::INDIVIDUAL`
